<template>
  <div class="kb-sidebar">
    <div class="kb-category-menu">
      <ul>
        <SidebarItem
          v-for="category in categoryList"
          :key="category.id"
          :category="category"
        />
      </ul>
    </div>
  </div>
</template>

  <script>
  import axios from '@axios'
import SidebarItem from './SidebarItem.vue'
export default {
  name: 'Sidebar',
  components: {
    SidebarItem
  },
  data() {
    return {
      title: '',
      faq_categories: [],
      isOpen: false
    }
  },
  computed: {
    categoryList() {
    return this.faq_categories.map((category) => {
      return {
        id: category.id,
        name: category.name,
        description: category.description,
        subcategories: category.sub_categories.map((subcategory) => {
          return {
            id: subcategory.id,
            name: subcategory.name
          }
        }),
  }})}

  },
  mounted() {
    this.title = 'FAQ'
    this.fetchFaqCategories()
  },
  methods: {
    async fetchFaqCategories() {
      try {
        const {data} = await axios.get('/api/v2/faq_categories')
        this.faq_categories = data.faq_categories
      } catch (error) {
          //
      }
    },

  },


}
</script>

<style lang="scss" scoped>
</style>
